/**
 * @generated SignedSource<<db8a52471abf24c38f07063bdea49391>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RestoreMailingListInput = {
  id: string;
};
export type MailingListDetailsViewRestoreMutation$variables = {
  input: RestoreMailingListInput;
};
export type MailingListDetailsViewRestoreMutation$data = {
  readonly restoreMailingList: {
    readonly archivedAt: any | null | undefined;
    readonly id: string;
  };
};
export type MailingListDetailsViewRestoreMutation = {
  response: MailingListDetailsViewRestoreMutation$data;
  variables: MailingListDetailsViewRestoreMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MailingList",
    "kind": "LinkedField",
    "name": "restoreMailingList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "archivedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MailingListDetailsViewRestoreMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MailingListDetailsViewRestoreMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2e7e1d77d76786124cb635d5c307c336",
    "id": null,
    "metadata": {},
    "name": "MailingListDetailsViewRestoreMutation",
    "operationKind": "mutation",
    "text": "mutation MailingListDetailsViewRestoreMutation(\n  $input: RestoreMailingListInput!\n) {\n  restoreMailingList(input: $input) {\n    id\n    archivedAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "02a34ecc133d2915ced6510a6758ed12";

export default node;
